"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeUrl = normalizeUrl;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function normalizeUrl(originalUrl) {
  if (!originalUrl) {
    return {
      url: originalUrl,
      tokenize: originalUrl,
      properties: null
    };
  }
  var url = originalUrl;
  if (originalUrl && !originalUrl.includes('http')) {
    url = "".concat(window.location.origin).concat(window.location.pathname).concat(originalUrl);
  }
  var parsedUrl = new URL(url);
  var modifiedUrl = "".concat(parsedUrl.origin).concat(parsedUrl.pathname);

  // MongoDB ObjectId regex: 24 characters long, hexadecimal digits
  var objectIdPattern = /[a-f\d]{24}/gi;

  // Object to store the mapping of param names to original ObjectId values
  var paramMap = {};

  // Keep a counter to increment parameter names
  var paramCounter = 1;

  // Replace each ObjectId with a sequential parameter like :param1, :param2, etc.
  modifiedUrl = modifiedUrl.replace(objectIdPattern, function (match) {
    var paramName = "param".concat(paramCounter);

    // Store the pair in the paramMap object
    paramMap[paramName] = match;
    paramCounter += 1;
    return ":".concat(paramName);
  });

  // Remove trailing slash
  modifiedUrl = modifiedUrl.replace(/\/$/, '');
  var queryParams = {};
  parsedUrl.searchParams.forEach(function (value, key) {
    queryParams[key] = value;
  });
  return {
    url: url,
    tokenize: modifiedUrl,
    properties: _objectSpread(_objectSpread({}, paramMap), queryParams)
  };
}